import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { AppendCommonHeaders } from './append-common-headers.interceptor'

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AppendCommonHeaders, multi: true }],
})
export class CommonHeadersModule {}
